// extracted by mini-css-extract-plugin
export var divider = "_fn-7";
export var itemsToggle = "_fn-8";
export var mergeModal = "_fn-1";
export var optionCard = "_fn-4";
export var radioGroup = "_fn-6";
export var radioOption = "_fn-0";
export var selected = "_fn-5";
export var shipmentOptions = "_fn-2";
export var tableOptions = "_fn-3";